import React, { useEffect, useRef, useState } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Button, Input, Space, Table } from 'antd';
// import Highlighter from 'react-highlight-words';
import { getAllStudentsView } from '../../HttpRequest/userdetails';


  // date  email  age  listed   application
// const data = [
//   {
//     key: '1',
  
//     date:"3" ,
//     email:"jond",
//     age: 32,
//     listed:"asdasd",
//     application:"3",
//   },
//   {
//     key: '2',
//     name: 'Joe Black',
//     age: 42,
//     address: 'London No. 1 Lake Park',
//   },
//   {
//     key: '4',
//     name: 'Jim Red',
//     age: 32,
//     address: 'London No. 2 Lake Park',
//   },
// ];



const Table2 = () => {
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [student , setStudent]=  useState({
    apidata:[],
    api:"",
    page:0,
    get:"",
    size:10,

  })

  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };


  // {
  //   "id": 11101,
  //   "userUUID": "d73b6b00-a5d0-42fb-bb94-1815162aa410",
  //   "firstName": "Test",
  //   "lastName": "Overseas Education Platform",
  //   "email": "naveen.yalamati@gatnix.com",
  //   "createdDate": "2023-11-25",
  //   "profilePic": "aLLPaS3uJxqmMID1awcJ6umkyoD7FzDIblank-profile-picture-973460_1280.webp",
  //   "phoneNumber": "919704161363",
  //   "totalWishlistCount": 4,
  //   "totalAppliedUniversityCount": 2},
     
      
  useEffect(() => {
    const handleStudentGetCallApi = async () => {
      try {
        const response = await getAllStudentsView("user", student.page, student.size);
        console.log(response.data);
        setStudent({
          ...student,
          apidata: response.data,
        });
      } catch (error) {
        console.error("Error fetching student data:", error);
      }
    };
  
    handleStudentGetCallApi();
  }, []);
  
  // Move the data population logic inside the useEffect
  const data = [];
  
  console.log("student.apidata:", student.apidata);
  
  if (Array.isArray(student.apidata.data)) {
    data.push(
      ...student.apidata.data.map((item, index) => ({
        key: index,
        date: item.createdDate,
        name:item.firstName,
        email: item.email,
        phone:item.phoneNumber,
        listed: item.totalWishlistCount,
        application: item.totalWishlistCount,
      }))
    );
  }  else {
  console.error("student.apidata is not an array");
}
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });
  const columns = [
    {
      title: 'Created Date',
      dataIndex: 'date',
      key: 'date',
      width: '30%',
      ...getColumnSearchProps('date'),
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: '30%',
      ...getColumnSearchProps('name'),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      width: '30%',
      ...getColumnSearchProps('email'),
    },
    {
      title: 'Phone Number',
      dataIndex: 'phone',
      key: 'phone',
      width: '30%',
      ...getColumnSearchProps('phone'),
    },
    {
      title: 'Total Shortlisted',
      dataIndex: 'listed',
      key: 'listed',
      width: '20%',
      ...getColumnSearchProps('listed'),
    },
    // {
    //   title: 'Total Shortlisted',
    //   dataIndex: 'age',
    //   key: 'age',
    //   width: '20%',
    //   ...getColumnSearchProps('age'),
    // },
    {
        title: 'Total',
        dataIndex: 'application',
        key: 'application',
        width: '20%',
        ...getColumnSearchProps('application'),
      },
  ];
  return <Table columns={columns} dataSource={data} />;
};
export default Table2;